module.exports = __webpack_public_path__ + "static/media/thomas.66bec7a9.png";